import { SyncLogDto } from './sync-log.dto';

export class SyncLog {
    readonly id: string;
    readonly status: string;
    readonly error: string;
    readonly startedAt: string;
    readonly endedAt: string;
    readonly duration: number;
    readonly productsCreatedCount: number;
    readonly productsDeletedCount: number;
    readonly productsRestoredCount: number;

    constructor(dto: SyncLogDto) {
        this.id = dto.id;
        this.status = dto.status;
        this.error = dto.error;
        this.startedAt = dto.startedAt;
        this.endedAt = dto.endedAt;
        this.duration = dto.duration;
        this.productsCreatedCount = dto.productsCreatedCount;
        this.productsDeletedCount = dto.productsDeletedCount;
        this.productsRestoredCount = dto.productsRestoredCount;
    }
}
